export default __webpack_public_path__ + "static/media/pl2_image_WEB_3.42931dd7.png";